exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clickable[data-v-14eee374]{cursor:pointer}", ""]);

// exports
